/**
 * 厅战入口
 */

import React, { useEffect } from 'react';
import styled from 'styled-components';
import { useSetState, useStateful } from 'react-hanger';

import { UiToast } from '@/components';
import { request } from '@/lib';
import { globalStore } from '@/stores';
import Form from '@/modules/widgets/ui/form';
import { room } from '@/modules/widgets/lib';

import RoomBase from './room-base';

const StageLunchFlight = (props) => {
  const { item } = props;
  const descTip = useStateful('');
  const timeOptions = useStateful([]);

  const formData = useSetState<any>({
    //
  });

  useEffect(() => {
    request.funny.get('api/v1/multiRoom/war/minuteList').then((source: any) => {
      const list = source.data || [];
      const options = list.map((item) => {
        return {
          value: item.minute,
          label: `${item.minute}分钟`,
        };
      });
      timeOptions.setValue(options);
    });
  }, []);

  const handleSave = () => {
    if (!formData.state.minute) {
      descTip.setValue('PK时长不能为空');
      return false;
    }

    request.funny
      .post('api/v1/multiRoom/war/invite', {
        roomId: room.getRoomId(),
        target: item.roomId || item.uid,
        ...formData.state,
      })
      .then(() => {
        UiToast.success('PK邀请已发送');
        globalStore.modal.remove('fightRankUsers');
        globalStore.modal.remove('fightInviteList');
        props.onClose();
      })
      .catch((err) => {
        UiToast.fail(err.msg || '操作失败');
      });

    return true;
  };

  const handleInputChange = (name, value) => {
    descTip.setValue('');
    formData.setState({
      [name]: value,
    });
  };

  return (
    <Wrap>
      <RoomBase item={item} />
      <Form.Form className="form" inline>
        <Form.Select
          label="PK时长"
          name="minute"
          value={formData.state.minute}
          onChange={handleInputChange}
          options={timeOptions.value}
        />
        <Form.FormErrTipText tip={descTip.value} />
        <Form.FormActions label="发起邀请" onClick={handleSave} />
      </Form.Form>
    </Wrap>
  );
};

const Wrap = styled.div`
  padding-top: 40px;
  height: 480px;
  box-sizing: border-box;

  .form {
    padding: 36px 16px 0;
    .form-item-label {
      white-space: nowrap;
    }
    .form-item-input {
      width: 372px;
    }
    .form-item-options {
      left: 47px;
      width: 372px;
    }
    &-actions {
      position: absolute;
      left: 0;
      bottom: 20px;
      width: 100%;
      text-align: center;
      .btn {
        width: 200px;
        height: 40px;
        border-radius: 40px;
        margin: auto;
        background: linear-gradient(270deg, #c669ff 0%, #7555f7 100%);
        border: 0;
      }
    }
  }
`;

export default StageLunchFlight;
